import {
  ListBakery2bQueryRes,
  ListBakery2bStatisticQueryRes,
} from '../services/bakery2b.service.ts';
import { GridSortModel } from '@mui/x-data-grid/models/gridSortModel';

export enum Bakery2bTabs {
  clients = 'clients',
  settings = 'settings',
  statistic = 'statistic',
}

export interface ITabState {
  listBakery2bClient: ListBakery2bQueryRes;
  listBakery2bClientSortModel: GridSortModel;
  statisticList: ListBakery2bStatisticQueryRes;
  statisticListSortModel: GridSortModel;
}
